// extracted by mini-css-extract-plugin
module.exports = {"resolveContent":"service_resolveContent__2mn13"};